import * as React from 'react';
import { twMerge } from 'tailwind-merge';

export const HeroCover = () => {
  return (
    <div className='pointer-events-none absolute start-0 top-0 z-10 w-full xl:top-0 2xl:top-[-1vw]'>
      <HeroCoverSvg className='absolute start-0 top-0 h-auto w-full' />
    </div>
  );
};

export default HeroCover;

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const HeroCoverSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <>
    <svg
      width={1440}
      height={811}
      viewBox='0 0 1440 811'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
      className={twMerge('hidden md:block', props.className)}
      style={{
        willChange: 'transform',
      }}
    >
      <defs>
        <clipPath id='bgblur_0_2084_8646_clip_path'>
          <path d='M1440 811H0V0H1440V811ZM88 48C65.9086 48 48 65.9086 48 88V722C48 744.091 65.9086 762 88 762H1352C1374.09 762 1392 744.091 1392 722V88C1392 65.9086 1374.09 48 1352 48H984C966.603 48 952.449 61.8825 952.011 79.1738L951.989 80.8262C951.551 98.1175 937.397 112 920 112H520C502.603 112 488.449 98.1175 488.011 80.8262L487.989 79.1738C487.551 61.8825 473.397 48 456 48H88Z' />
        </clipPath>

        <linearGradient id='borderGradient' x1='0%' y1='0%' x2='0%' y2='100%'>
          <stop offset='0%' stopColor='white' stopOpacity='0.2' />
          <stop offset='100%' stopColor='white' stopOpacity='0' />
        </linearGradient>
      </defs>

      {/* Border path - same shape as clip path but as a stroke with gradient */}
      <path
        d='M88 48C65.9086 48 48 65.9086 48 88V722C48 744.091 65.9086 762 88 762H1352C1374.09 762 1392 744.091 1392 722V88C1392 65.9086 1374.09 48 1352 48H984C966.603 48 952.449 61.8825 952.011 79.1738L951.989 80.8262C951.551 98.1175 937.397 112 920 112H520C502.603 112 488.449 98.1175 488.011 80.8262L487.989 79.1738C487.551 61.8825 473.397 48 456 48H88Z'
        fill='none'
        stroke='url(#borderGradient)'
        strokeWidth='2'
      />

      {/* Strong background blur layer at top */}
      <foreignObject x={0} y={0} width={1440} height={600}>
        <div
          style={{
            ...(isSafari
              ? { background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0))' }
              : {
                  backdropFilter: 'blur(6px)',
                  background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0))',
                }),
            // from top to bottom transparent to semi-transparent black

            height: '100%',
            width: '100%',
            clipPath: 'url(#bgblur_0_2084_8646_clip_path)',
          }}
        />
      </foreignObject>
    </svg>
    <HeroCoverMobileSvg {...props} className={twMerge('mt-[-1vw] md:hidden', props.className)} />
  </>
);

const HeroCoverMobileSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={402}
    height={874}
    viewBox='0 0 402 874'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <defs>
      <clipPath id='bgblur_0_2477_139763_clip_path'>
        <path d='M402 874H0V0H402V874ZM52 54C34.3269 54 20 68.3269 20 86V822C20 839.673 34.3269 854 52 854H350C367.673 854 382 839.673 382 822V86C382 68.3269 367.673 54 350 54H237C230.476 54 225.168 59.2061 225.004 65.6904L224.996 66.3096C224.832 72.7939 219.524 78 213 78H189C182.476 78 177.168 72.7939 177.004 66.3096L176.996 65.6904C176.832 59.2061 171.524 54 165 54H52Z' />
      </clipPath>
      <linearGradient id='borderGradient2' x1='0%' y1='0%' x2='0%' y2='100%'>
        <stop offset='0%' stopColor='white' stopOpacity='0.2' />
        <stop offset='100%' stopColor='white' stopOpacity='0' />
      </linearGradient>
    </defs>

    <foreignObject width={422} height={400}>
      <div
        style={{
          backdropFilter: 'blur(6px)',
          background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.08), rgba(0, 0, 0, 0))',
          height: '100%',
          width: '100%',
          clipPath: 'url(#bgblur_0_2477_139763_clip_path)',
        }}
      />
    </foreignObject>

    {/* Border path */}
    <path
      d='M52 54C34.3269 54 20 68.3269 20 86V822C20 839.673 34.3269 854 52 854H350C367.673 854 382 839.673 382 822V86C382 68.3269 367.673 54 350 54H237C230.476 54 225.168 59.2061 225.004 65.6904L224.996 66.3096C224.832 72.7939 219.524 78 213 78H189C182.476 78 177.168 72.7939 177.004 66.3096L176.996 65.6904C176.832 59.2061 171.524 54 165 54H52Z'
      stroke='url(#borderGradient2)'
      strokeWidth='2'
      fill='none'
    />
  </svg>
);

export const MenuOverlaySvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    // width={1344}
    // height={472}
    viewBox='0 0 1344 472'
    preserveAspectRatio='none'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M1344 432C1344 454.091 1326.09 472 1304 472H40C17.9086 472 0 454.091 0 432V40C0 17.9086 17.9086 0 40 0H408C425.673 0 440 14.3269 440 32C440 49.6731 454.327 64 472 64H872C889.673 64 904 49.6731 904 32C904 14.3269 918.327 0 936 0H1304C1326.09 0 1344 17.9086 1344 40V432Z'
      fill='#18181B'
    />
  </svg>
);
